import type { KnowledgeBaseEntity } from '../types';

/** Human-readable display names for backend knowledge base categories. */
const CATEGORY_LABELS: Record<KnowledgeBaseEntity['category'], string> = {
  amenity: 'Amenity',
  restaurant: 'Restaurant',
  activity: 'Activity',
  event: 'Event',
  spa_service: 'Spa Service',
  golf: 'Golf',
  room: 'Room',
  offer: 'Offer',
  service: 'Service',
  attraction: 'Attraction',
  faq: 'FAQ',
  notice: 'Notice',
  policy: 'Policy',
};

/**
 * Get a display-friendly label for a knowledge base category.
 * Falls back to title-casing the raw value if unknown.
 */
export function getCategoryLabel(category: string): string {
  return CATEGORY_LABELS[category as KnowledgeBaseEntity['category']]
    ?? category.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
